import React, { useEffect, useState } from "react";
import { ClassNames, getCookie } from "../../../../../helper";
import Auth from "./Auth";
import List from "./List";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice";
import { updateDataInMongoDb } from "../../../../../services/mongod.data";

const ConnectWithBrevo = ({
  installHandler,
  integrationData,
  setIntegrationData,
  page,
  setPage,
  integration,
  setIntegration,
}) => {
  const [validAuth, setValidAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  useEffect(() => {
    if(integration){
      setValidAuth(true);
    }
  }, [integration]);

  const handleFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await updateDataInMongoDb(
        user,
        "graph-integration",
        ["brevo"],
        integrationData
      );
      setIntegration(true);
      setPage(1);
      setLoading(false);
      installHandler(false);
    } catch (error) {
      setLoading(false);
      installHandler(false);
      return;
    }
  };

  return (
    <div className="my-6 text-gray-500 relative">
      {page === 1 ? (
        <Auth
          integrationData={integrationData}
          setIntegrationData={setIntegrationData}
          setValidAuth={setValidAuth}
        />
      ) : (
        <List
          integrationData={integrationData}
          setIntegrationData={setIntegrationData}
        />
      )}

      <hr className="my-3" />
      <div className="flex justify-between items-center">
        <div className="flex gap-2">
          <p
            className={`w-2 h-2 rounded-full ${
              page === 1 ? "bg-indigo-600" : "bg-gray-300"
            }`}
          ></p>
          <p
            className={`w-2 h-2 rounded-full ${
              page === 2 ? "bg-indigo-600" : "bg-gray-300"
            }`}
          ></p>
        </div>
        <div className="space-x-4">
          {page === 1 ? (
            <>
              <button
                className="text-gray-800 hover:text-indigo-600"
                onClick={() => installHandler(false)}
              >
                Cancel
              </button>
              <button
                className={ClassNames(
                  "px-6 py-2 rounded-md",
                  validAuth
                    ? "text-white bg-indigo-600"
                    : "disabled bg-gray-200 text-gray-500 cursor-auto"
                )}
                onClick={() => setPage(2)}
                disabled={!validAuth}
              >
                Next
              </button>
            </>
          ) : (
            <>
              <button
                className="text-gray-800 hover:text-indigo-600"
                onClick={() => setPage(1)}
              >
                Previous
              </button>
              <button
                className={ClassNames(
                  "px-6 py-2 rounded-md bg-indigo-600 text-white",
                  loading ? "opacity-50 cursor-not-allowed" : ""
                )}
                onClick={handleFinish}
                disabled={loading}
              >
                {loading ? "Loading..." : "Finish"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectWithBrevo;
